import React from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import {Link} from "react-router-dom";
import moment from "moment";

import JwtClient from "./JwtClient";
import Logout from "./utils";
import Alert from "./Alert";

export default class SpeedXManifestList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            manifests: [],
            loading: true,
            downloading: '', // id of the manifest being downloaded
            unmanifestedCount: null, // packages the create page offers, null until fetched
        };
    }

    render() {
        return (
            <Container>
                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                    <h4 className="mb-0">SpeedX Manifests</h4>
                    <Link to="/speedx-manifests/new" className="btn btn-primary">
                        Create manifest
                        {this.state.unmanifestedCount !== null ?
                            <span className="badge badge-light ml-2">{this.state.unmanifestedCount}</span> : null}
                    </Link>
                </div>

                {this.state.alert ? <Alert>{this.state.alert}</Alert> : null}

                {this.state.loading ?
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div> :
                    this.state.manifests.length === 0 ? <p>No SpeedX manifests yet</p> :
                        <Table>
                            <thead>
                            <tr>
                                <th>Created</th>
                                <th>Shipment code</th>
                                <th>Packages</th>
                                <th>Manifest</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.manifests.map(m => (
                                <tr key={m.id}>
                                    <td>{moment(m.created_at).format('MM/DD/YY h:mm a')}</td>
                                    <td>{m.shipment_code}</td>
                                    <td>{this.packages(m)}</td>
                                    <td>{this.download(m)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                }
            </Container>
        )
    }

    packages = (m) => (
        <span>
            {m.success_count} / {m.package_count}
            {m.fail_count > 0 ?
                <span className="text-danger ml-2">({m.fail_count} refused by SpeedX)</span> : null}
        </span>
    );

    download = (m) => {
        if (this.state.downloading === m.id) {
            return <div className="spinner-border spinner-border-sm"></div>
        }
        return <button className="btn btn-link p-0" onClick={() => this.getPDFs(m.id)}>Download</button>
    };

    componentDidMount() {
        this.getManifests();
        this.getUnmanifestedCount();
    }

    // The badge is only a hint, so a failure leaves it hidden instead of
    // putting an alert over the manifest list.
    getUnmanifestedCount() {
        JwtClient.get(`/api/v1/admin/speedx-packages/unmanifested`)
            .then(response => {
                this.setState({unmanifestedCount: response.data.packages.length});
            })
            .catch(err => {
                if (err.response && err.response.status === 401) {
                    Logout();
                }
            })
    }

    getManifests() {
        this.setState({loading: true});
        JwtClient.get(`/api/v1/admin/speedx-manifests`)
            .then(response => {
                this.setState({manifests: response.data.manifests});
            })
            .catch(err => {
                if (err.response) {
                    if (err.response.status === 401) {
                        Logout();
                    }
                    this.setState({alert: 'Error on fetching, status: ' + err.response.status});
                } else {
                    this.setState({alert: JSON.stringify(err)});
                }
            })
            .finally(() => {
                this.setState({loading: false});
            })
    }

    getPDFs = (id) => {
        this.setState({downloading: id});
        JwtClient.get(`/api/v1/admin/speedx-manifests/${id}/pdf`)
            .then(response => {
                response.data.pdfs.forEach(p => this.openBase64InNewTab(p.pdf_base64));
            })
            .catch(err => {
                if (!err.response) {
                    this.setState({alert: JSON.stringify(err)});
                    return
                }
                if (err.response.status === 401) {
                    Logout();
                    return
                }
                this.setState({alert: 'Error on downloading, status: ' + err.response.status});
            })
            .finally(() => {
                this.setState({downloading: ''});
            })
    };

    openBase64InNewTab = (data) => {
        data = 'data:application/pdf;base64,' + data;
        let w = window.open('about:blank');
        setTimeout(function () {
            w.document.write("<iframe width='100%' height='100%' src=" + data + '>');
        }, 0);
    }
}
